import { useContext } from 'react';
import { WorkoutContext } from './WorkoutContext';

/**
 * Custom hook to use the workout context
 * @returns {Object} The workout context
 */
export function useWorkout() {
    const context = useContext(WorkoutContext);

    if (!context) {
        throw new Error('useWorkout must be used within a WorkoutProvider');
    }

    return context;
}

